export const COMPONENT_NAME = "shared-validate";
